import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5ZM7.5547 5.66795C7.24784 5.46338 6.8533 5.44431 6.52814 5.61833C6.20298 5.79235 6 6.13121 6 6.5V10.5C6 10.8688 6.20298 11.2077 6.52814 11.3817C6.8533 11.5557 7.24784 11.5366 7.5547 11.3321L10.5547 9.33205C10.8329 9.14659 11 8.83435 11 8.5C11 8.16565 10.8329 7.85342 10.5547 7.66795L7.5547 5.66795Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }